// extracted by mini-css-extract-plugin
export default {"slider":"Slider_slider__9xMUs","track":"Slider_track__9yfjl","dualSlider":"Slider_dualSlider__YjVH4","dualTrack":"Slider_dualTrack__eZbXK","thumb":"Slider_thumb__PpNVF"};